import { render, staticRenderFns } from "./Methodological_Tools.vue?vue&type=template&id=d3080bac&scoped=true&"
import script from "./Methodological_Tools.vue?vue&type=script&lang=js&"
export * from "./Methodological_Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3080bac",
  null
  
)

export default component.exports